// src/features/eventos/hooks/useEventosList.js
import { useCallback, useEffect, useState } from "react";
import { getToken } from "../../../services/authService";

export function useEventosList(apiUrl, estadoTiempo) {
    const [eventos, setEventos] = useState([]);
    const [loading, setLoading] = useState(false);

    const [infoModal, setInfoModal] = useState({
        open: false,
        title: "",
        message: "",
    });

    const fetchEventos = useCallback(async () => {
        try {
            setLoading(true);
            const qs = estadoTiempo ? `?estado=${encodeURIComponent(estadoTiempo)}` : "";
            const res = await fetch(`${apiUrl}/api/eventos/all${qs}`, {
                headers: { Authorization: "Bearer " + getToken() },
            });
            const data = await res.json();
            setEventos(Array.isArray(data) ? data : []);
        } catch (err) {
            console.error("Error al cargar eventos:", err);
            setInfoModal({
                open: true,
                title: "Error",
                message: "No se pudieron cargar los eventos.",
            });
        } finally {
            setLoading(false);
        }
    }, [apiUrl, estadoTiempo]);

    useEffect(() => {
        fetchEventos();
    }, [fetchEventos]);

    const eliminarEvento = useCallback(
        async (eventoId) => {
            try {
                const res = await fetch(`${apiUrl}/api/eventos/delete/${eventoId}`, {
                    method: "DELETE",
                    headers: { Authorization: "Bearer " + getToken() },
                });

                if (!res.ok) {
                    const errText = await res.text().catch(() => "");
                    setInfoModal({
                        open: true,
                        title: "No se puede eliminar",
                        message:
                            errText || "No se pudo eliminar el evento. Puede estar referenciado.",
                    });
                    return { ok: false };
                }

                setEventos((prev) => prev.filter((ev) => ev.id !== eventoId));
                return { ok: true };
            } catch (err) {
                console.error("Error eliminando evento:", err);
                setInfoModal({
                    open: true,
                    title: "No se puede eliminar",
                    message: "Error de red eliminando el evento.",
                });
                return { ok: false };
            }
        },
        [apiUrl]
    );

    const duplicarEvento = useCallback(
        async (eventoId) => {
            try {
                const res = await fetch(`${apiUrl}/api/eventos/duplicate/${eventoId}`, {
                    method: "POST",
                    headers: {
                        Authorization: "Bearer " + getToken(),
                        "Content-Type": "application/json",
                    },
                });

                if (!res.ok) {
                    const errText = await res.text().catch(() => "");
                    setInfoModal({
                        open: true,
                        title: "Error al duplicar",
                        message: errText || "No se pudo duplicar el evento.",
                    });
                    return { ok: false };
                }

                const nuevoEvento = await res.json();
                setEventos((prev) => [...prev, nuevoEvento]);
                return { ok: true, data: nuevoEvento };
            } catch (err) {
                console.error("Error duplicando evento:", err);
                setInfoModal({
                    open: true,
                    title: "Error al duplicar",
                    message: "Error de red duplicando el evento.",
                });
                return { ok: false };
            }
        },
        [apiUrl]
    );

    return {
        eventos,
        setEventos,
        loading,
        infoModal,
        setInfoModal,
        refetch: fetchEventos,
        eliminarEvento,
        duplicarEvento,
    };
}
